import {css} from "lit";
import {commonStyles} from "../../common/styles/Common.js";
import {iconStyles} from "../../common/styles/Icons.js";
import {customScrollStyles} from "../../common/styles/CustomScrollBar.js";
import {labeledTextInputStyles} from "../../common/controls-inputs/LabeledTextInput.styles.js";

export const citationNotesStyles = [
	labeledTextInputStyles,
	customScrollStyles,
	commonStyles,
	iconStyles,
	css`
	h3, p {
		text-align: center;
	}

	h3 {
		margin-top: 0;
		font-weight: 500;
	}

	p {
		margin: 16px;
	}

	.citation-source-note {
		margin-bottom: 20px;
	}

	textarea {
		height: 110px;
	}

	.citation-source-note-label {
		display: flex;
		justify-content: space-between;
		margin-bottom: 5px;
		height: 21px;
	}

	.citation-note-delete::part(button) {
		padding: 4px;
	}

	.citation-note-delete.hidden {
		display: none;
	}

	label {
		display: inline-grid;
		grid-template: 100%/100%;
		color: inherit;
		line-height: inherit;
		margin: 0;
		padding: 2px 5px 0;
		border-bottom: 1px dashed transparent;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	label::after, input.label-input {
		width: auto;
		grid-area: 1/1/2/2;
		padding: 0;
		font-size: var(--pn-font-size-small);
	}

	label::after {
		content: attr(data-value) ' ';
		visibility: hidden;
		white-space: nowrap;
	}

	input.label-input {
		height: auto;
		border: none;
		border-bottom: 1px dashed transparent;
		border-radius: 0;
		background: transparent;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	input.label-input.editable:hover, input.label-input.editable:focus {
		border: none;
		border-bottom: 1px dashed gray;
		// .tab-focus();
		outline: none;
	}

	#btn-citation-add-note {
		display: block;
		margin-top: 20px;
		text-align: right;
	}
`];
